import { createApi } from "@reduxjs/toolkit/query/react";
import { GOODS_DELIVERY_NOTE } from "@utils/constants/goods-request/delivery-note.constants";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export const deliveryNoteApi = createApi({
  reducerPath: "deliveryNoteApi",
  tagTypes: ["DeliveryNote"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllDeliveryNotes: builder.query<
      [],
      {
        page?: number;
        limit?: number;
        // customer_first_name?: string;
        direct_sales_invoice_code?: string;
        direct_sales_return_code?: string;
        search?: string;
        from_date?: any;
        to_date?: any;
        status?: string;
        reference_id?: string;
        business_unit_name?: string;
        customer_first_name?: string;
        business_unit_ids?: string;
        reference_ids?: string;
        reference_type?: string;
        customer_ids?: string;
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        search,

        from_date,
        to_date,
        status,
        reference_id,
        reference_type,
        business_unit_name,
        customer_first_name,

        business_unit_ids,
        reference_ids,
        customer_ids,
      }) => {
        const queryParams = {
          url: GOODS_DELIVERY_NOTE.GET_ALL,
          params: { page, limit },
        } as any;

        if (search) {
          queryParams.params.search = search;
        }


        if (from_date) {
          //@ts-ignore
          queryParams.params.from_date = from_date
        }

        if (to_date) {
          //@ts-ignore
          queryParams.params.to_date = to_date;
        }

        if (status) {
          //@ts-ignore
          queryParams.params.status = status;
        }

        if (reference_id) {
          //@ts-ignore
          queryParams.params.reference_id = reference_id;
        }

        if (reference_type) {
          //@ts-ignore
          queryParams.params.reference_type = reference_type;
        }

        if (business_unit_name) {
          //@ts-ignore
          queryParams.params.business_unit_name = business_unit_name;
        }


        if (customer_first_name) {
          //@ts-ignore
          queryParams.params.customer_first_name = customer_first_name;
        }

        if (business_unit_ids) {
          //@ts-ignore
          queryParams.params.business_unit_ids = business_unit_ids;
        }

        if (reference_ids) {
          //@ts-ignore
          queryParams.params.reference_ids = reference_ids;
        }

        if (customer_ids) {
          //@ts-ignore
          queryParams.params.customer_ids = customer_ids;
        }

        return queryParams;
      },
    }),
    getGoodsDelivery: builder.query<
      any,
      { goods_delivery_id: string | number }
    >({
      query: ({ goods_delivery_id }) =>
        `${GOODS_DELIVERY_NOTE.GET_ONE}${goods_delivery_id}`,
    }),
    updateGoodsDelivery: builder.mutation({
      query: ({ id, body }) => ({
        url: `${GOODS_DELIVERY_NOTE.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
    }),
    deleteGoodsDelivery: builder.mutation({
      query: ({ id }) => ({
        url: `${GOODS_DELIVERY_NOTE.DELETE}${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllDeliveryNotesQuery,
  useGetGoodsDeliveryQuery,
  useLazyGetGoodsDeliveryQuery,
  useUpdateGoodsDeliveryMutation,
  useDeleteGoodsDeliveryMutation,
} = deliveryNoteApi;
